import { render, staticRenderFns } from "./SendMessageIsSharedMessagesRow.vue?vue&type=template&id=97b6832c&scoped=true&lang=pug"
import script from "./SendMessageIsSharedMessagesRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageIsSharedMessagesRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageIsSharedMessagesRow.vue?vue&type=style&index=0&id=97b6832c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b6832c",
  null
  
)

export default component.exports